import { useHelpCenter } from 'hooks/use-help-center';
import { useMemo } from 'react';

export function useHelpCenterVideo(productType: string, productSubType: string) {
  const { getTopicById, openTopicId } = useHelpCenter();

  const topicId = `${productType}.${productSubType}`;

  const link = useMemo(() => {
    const topic = getTopicById(topicId);
    if (!topic?.content) {
      return undefined;
    }

    const match = topic.content.match(/<tutorial-video url="([^"]+)"/);
    return match?.[1];
  }, [topicId, getTopicById]);

  const openLearnMore = () => (link ? openTopicId(topicId) : undefined);

  return { hasVideo: !!link, openLearnMore, videoLink: link };
}
